dmx.slideshow.transitions.unfold = function(slideshow, options) {
    return new dmx.slideshow.Transition(slideshow, Object.assign({
        requires3d: true,

        perspective: 1000,

        duration: 1500,

        direction: 'random',

        setup: function() {
            if (this.options.direction === 'random') {
                this.options.direction = this.random('horizontal', 'vertical');
            }

            this.slice1 = document.createElement('div');
            this.slice1.style.setProperty('position', 'absolute');
            this.slice1.style.setProperty('width', this.options.direction == 'horizontal' ? '100%' : '50%');
            this.slice1.style.setProperty('height', this.options.direction == 'horizontal' ? '50%' : '100%');
            this.slice1.style.setProperty('backface-visibility', 'hidden');
            this.slice1.style.setProperty('transform-style', 'preserve-3d');
            this.slice1.style.setProperty('transform-origin', '0% 0%');
            this.slice1.style.setProperty('transition', 'all ' + this.options.duration + 'ms ease-in-out');
            this.slice1.style.setProperty('background-size', this.width + 'px')
            this.slice1.style.setProperty('background-image', 'url("' + this.prevSlide.url + '")');

            this.slice2 = this.slice1.cloneNode();
            this.slice2.style.setProperty('width', '100%');
            this.slice2.style.setProperty('height', '100%');
            this.slice2.style.setProperty('top', this.options.direction == 'horizontal' ? '100%' : 0);
            this.slice2.style.setProperty('left', this.options.direction == 'horizontal' ? 0 : '100%');
            this.slice2.style.setProperty('background-image', 'url("' + this.nextSlide.url + '")');
            this.slice2.style.setProperty('transform', this.options.direction == 'horizontal' ? 'rotateX(-90deg)' : 'rotateY(90deg)');

            this.slice3 = this.slice2.cloneNode();
            this.slice3.style.setProperty('background-position', 'right bottom');
            this.slice3.style.setProperty('transform', this.options.direction == 'horizontal' ? 'rotateX(180deg)' : 'rotateY(-180deg)');

            this.slice4 = this.slice3.cloneNode();
            this.slice4.style.setProperty('background-image', 'url("' + this.prevSlide.url + '")');
            this.slice4.style.setProperty('transform', this.options.direction == 'horizontal' ? 'rotateX(-90deg)' : 'rotateY(90deg)');

            this.slice1.appendChild(this.slice2);
            this.slice2.appendChild(this.slice3);
            this.slice3.appendChild(this.slice4);

            slideshow.effectsContainer.appendChild(this.slice1);

            slideshow.effectsContainer.style.setProperty('perspective', this.options.perspective + 'px');
            slideshow.effectsContainer.style.setProperty('perspective-origin', '50% 50%');

            slideshow.slidesContainer.style.setProperty('display', 'none');
        },

        execute: function() {
            this.slice1.style.setProperty('transform', this.options.direction == 'horizontal' ? 'translateY(-100%)' : 'translateX(-100%)');
            this.slice2.style.setProperty('transform', this.options.direction == 'horizontal' ? 'rotateX(0deg)' : 'rotateY(0deg)');
            this.slice3.style.setProperty('transform', this.options.direction == 'horizontal' ? 'rotateX(0deg)' : 'rotateY(0deg)');
            this.slice4.style.setProperty('transform', this.options.direction == 'horizontal' ? 'rotateX(0deg)' : 'rotateY(0deg)');
            this.slice1.addEventListener('transitionend', this.finished.bind(this));
            setTimeout(this.finished.bind(this), this.options.duration);
        }
    }, options));
};
